import { render, staticRenderFns } from "./delete-dialog.vue?vue&type=template&id=4cccc8b3&scoped=true"
import script from "./delete-dialog.vue?vue&type=script&lang=js"
export * from "./delete-dialog.vue?vue&type=script&lang=js"
import style0 from "./delete-dialog.vue?vue&type=style&index=0&id=4cccc8b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cccc8b3",
  null
  
)

export default component.exports